var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 192,
    viewBox: "0 0 193 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    id: "electricity",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.738 144.919H170.892V121.547C170.892 119.968 169.611 118.687 168.031 118.687C166.452 118.687 165.171 119.968 165.171 121.547V186.28H116.08V101.301H165.171V108.198C165.171 109.777 166.452 111.058 168.031 111.058C169.611 111.058 170.892 109.777 170.892 108.198V98.4413C170.892 96.8618 169.611 95.5809 168.031 95.5809H128.949V2.86039C128.949 1.28086 127.669 0 126.089 0H66.5971C65.0175 0 63.7367 1.28086 63.7367 2.86039V45.6504H26.7363C25.1567 45.6504 23.8759 46.9313 23.8759 48.5108V118.837H2.86039C1.28086 118.837 0 120.118 0 121.698V189.14C0 190.719 1.28086 192 2.86039 192H86.229C86.2316 192 86.2339 192 86.2361 192H168.024C168.026 192 168.029 192 168.031 192H189.738C191.318 192 192.599 190.719 192.599 189.14V147.78C192.599 146.2 191.318 144.919 189.738 144.919ZM23.8759 186.279H5.72079V124.558H23.8759V186.279ZM83.3686 186.279H66.5971V186.28H29.5967V170.462H83.3686V186.279ZM83.3686 145.482H57.5893C56.0098 145.482 54.7289 146.763 54.7289 148.343C54.7289 149.922 56.0098 151.203 57.5893 151.203H83.3686V164.741H29.5967V151.203H44.2406C45.8201 151.203 47.101 149.922 47.101 148.343C47.101 146.763 45.8201 145.482 44.2406 145.482H29.5967V131.944H83.3686V145.482ZM83.3686 126.224H29.5967V112.685H83.3686V126.224ZM83.3686 106.965H29.5967V93.4266H83.3686V106.965ZM83.3686 87.7058H29.5967V74.1675H83.3686V87.7058ZM83.3686 68.4467H29.5967V51.3709H83.3686V68.4467ZM110.36 98.4417V186.28H89.0894V48.5105C89.0894 46.9309 87.8089 45.6501 86.229 45.6501H82.3292V39.9297C82.3292 38.3501 81.0488 37.0693 79.4688 37.0693C77.8889 37.0693 76.6085 38.3501 76.6085 39.9297V45.6501H69.4575V5.72079H123.228V95.5813H113.22C111.64 95.5813 110.36 96.8618 110.36 98.4417ZM186.878 186.279H170.892V150.64H186.878V186.279Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.738 144.919H170.892V121.547C170.892 119.968 169.611 118.687 168.031 118.687C166.452 118.687 165.171 119.968 165.171 121.547V186.28H116.08V101.301H165.171V108.198C165.171 109.777 166.452 111.058 168.031 111.058C169.611 111.058 170.892 109.777 170.892 108.198V98.4413C170.892 96.8618 169.611 95.5809 168.031 95.5809H128.949V2.86039C128.949 1.28086 127.669 0 126.089 0H66.5971C65.0175 0 63.7367 1.28086 63.7367 2.86039V45.6504H26.7363C25.1567 45.6504 23.8759 46.9313 23.8759 48.5108V118.837H2.86039C1.28086 118.837 0 120.118 0 121.698V189.14C0 190.719 1.28086 192 2.86039 192H86.229C86.2316 192 86.2339 192 86.2361 192H168.024C168.026 192 168.029 192 168.031 192H189.738C191.318 192 192.599 190.719 192.599 189.14V147.78C192.599 146.2 191.318 144.919 189.738 144.919ZM23.8759 186.279H5.72079V124.558H23.8759V186.279ZM83.3686 186.279H66.5971V186.28H29.5967V170.462H83.3686V186.279ZM83.3686 145.482H57.5893C56.0098 145.482 54.7289 146.763 54.7289 148.343C54.7289 149.922 56.0098 151.203 57.5893 151.203H83.3686V164.741H29.5967V151.203H44.2406C45.8201 151.203 47.101 149.922 47.101 148.343C47.101 146.763 45.8201 145.482 44.2406 145.482H29.5967V131.944H83.3686V145.482ZM83.3686 126.224H29.5967V112.685H83.3686V126.224ZM83.3686 106.965H29.5967V93.4266H83.3686V106.965ZM83.3686 87.7058H29.5967V74.1675H83.3686V87.7058ZM83.3686 68.4467H29.5967V51.3709H83.3686V68.4467ZM110.36 98.4417V186.28H89.0894V48.5105C89.0894 46.9309 87.8089 45.6501 86.229 45.6501H82.3292V39.9297C82.3292 38.3501 81.0488 37.0693 79.4688 37.0693C77.8889 37.0693 76.6085 38.3501 76.6085 39.9297V45.6501H69.4575V5.72079H123.228V95.5813H113.22C111.64 95.5813 110.36 96.8618 110.36 98.4417ZM186.878 186.279H170.892V150.64H186.878V186.279Z",
    fill: "url(#paint0_linear_406_2236)",
    className: "skbtPsrQ_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.22 61.9728C111.64 61.9728 110.36 63.2537 110.36 64.8332V73.414C110.36 74.994 111.64 76.2744 113.22 76.2744C114.8 76.2744 116.08 74.9936 116.08 73.414V64.8332C116.08 63.2537 114.8 61.9728 113.22 61.9728Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.22 61.9728C111.64 61.9728 110.36 63.2537 110.36 64.8332V73.414C110.36 74.994 111.64 76.2744 113.22 76.2744C114.8 76.2744 116.08 74.9936 116.08 73.414V64.8332C116.08 63.2537 114.8 61.9728 113.22 61.9728Z",
    fill: "url(#paint1_linear_406_2236)",
    className: "skbtPsrQ_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 61.9728C94.7647 61.9728 93.4842 63.2537 93.4842 64.8332V73.414C93.4842 74.994 94.7651 76.2744 96.3446 76.2744C97.9245 76.2744 99.205 74.9936 99.205 73.414V64.8332C99.205 63.2537 97.9245 61.9728 96.3446 61.9728Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 61.9728C94.7647 61.9728 93.4842 63.2537 93.4842 64.8332V73.414C93.4842 74.994 94.7651 76.2744 96.3446 76.2744C97.9245 76.2744 99.205 74.9936 99.205 73.414V64.8332C99.205 63.2537 97.9245 61.9728 96.3446 61.9728Z",
    fill: "url(#paint2_linear_406_2236)",
    className: "skbtPsrQ_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.22 37.0693C111.64 37.0693 110.36 38.3502 110.36 39.9297V48.5105C110.36 50.0901 111.64 51.3709 113.22 51.3709C114.8 51.3709 116.08 50.0901 116.08 48.5105V39.9297C116.08 38.3502 114.8 37.0693 113.22 37.0693Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.22 37.0693C111.64 37.0693 110.36 38.3502 110.36 39.9297V48.5105C110.36 50.0901 111.64 51.3709 113.22 51.3709C114.8 51.3709 116.08 50.0901 116.08 48.5105V39.9297C116.08 38.3502 114.8 37.0693 113.22 37.0693Z",
    fill: "url(#paint3_linear_406_2236)",
    className: "skbtPsrQ_7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 37.0693C94.7647 37.0693 93.4842 38.3502 93.4842 39.9297V48.5105C93.4842 50.0901 94.7651 51.3709 96.3446 51.3709C97.9245 51.3709 99.205 50.0901 99.205 48.5105V39.9297C99.205 38.3502 97.9245 37.0693 96.3446 37.0693Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 37.0693C94.7647 37.0693 93.4842 38.3502 93.4842 39.9297V48.5105C93.4842 50.0901 94.7651 51.3709 96.3446 51.3709C97.9245 51.3709 99.205 50.0901 99.205 48.5105V39.9297C99.205 38.3502 97.9245 37.0693 96.3446 37.0693Z",
    fill: "url(#paint4_linear_406_2236)",
    className: "skbtPsrQ_9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4688 12.1657C77.8889 12.1657 76.6084 13.4466 76.6084 15.0261V23.6069C76.6084 25.1865 77.8892 26.4673 79.4688 26.4673C81.0487 26.4673 82.3292 25.1865 82.3292 23.6069V15.0261C82.3292 13.4466 81.0491 12.1657 79.4688 12.1657Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_10"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4688 12.1657C77.8889 12.1657 76.6084 13.4466 76.6084 15.0261V23.6069C76.6084 25.1865 77.8892 26.4673 79.4688 26.4673C81.0487 26.4673 82.3292 25.1865 82.3292 23.6069V15.0261C82.3292 13.4466 81.0491 12.1657 79.4688 12.1657Z",
    fill: "url(#paint5_linear_406_2236)",
    className: "skbtPsrQ_11"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.22 12.1657C111.64 12.1657 110.36 13.4466 110.36 15.0261V23.6069C110.36 25.1865 111.64 26.4673 113.22 26.4673C114.8 26.4673 116.08 25.1865 116.08 23.6069V15.0261C116.08 13.4466 114.8 12.1657 113.22 12.1657Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_12"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.22 12.1657C111.64 12.1657 110.36 13.4466 110.36 15.0261V23.6069C110.36 25.1865 111.64 26.4673 113.22 26.4673C114.8 26.4673 116.08 25.1865 116.08 23.6069V15.0261C116.08 13.4466 114.8 12.1657 113.22 12.1657Z",
    fill: "url(#paint6_linear_406_2236)",
    className: "skbtPsrQ_13"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 12.1657C94.7647 12.1657 93.4842 13.4466 93.4842 15.0261V23.6069C93.4842 25.1865 94.7651 26.4673 96.3446 26.4673C97.9245 26.4673 99.205 25.1865 99.205 23.6069V15.0261C99.205 13.4466 97.9245 12.1657 96.3446 12.1657Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_14"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 12.1657C94.7647 12.1657 93.4842 13.4466 93.4842 15.0261V23.6069C93.4842 25.1865 94.7651 26.4673 96.3446 26.4673C97.9245 26.4673 99.205 25.1865 99.205 23.6069V15.0261C99.205 13.4466 97.9245 12.1657 96.3446 12.1657Z",
    fill: "url(#paint7_linear_406_2236)",
    className: "skbtPsrQ_15"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.692 87.4459C110.534 88.1742 110.047 89.6894 110.579 90.9541C111.036 92.033 112.111 92.7469 113.288 92.718C114.488 92.6886 115.555 91.8953 115.934 90.7577C116.768 88.2558 113.907 86.0519 111.692 87.4459Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_16"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.692 87.4459C110.534 88.1742 110.047 89.6894 110.579 90.9541C111.036 92.033 112.111 92.7469 113.288 92.718C114.488 92.6886 115.555 91.8953 115.934 90.7577C116.768 88.2558 113.907 86.0519 111.692 87.4459Z",
    fill: "url(#paint8_linear_406_2236)",
    className: "skbtPsrQ_17"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 87.0002C94.7647 87.0002 93.4842 88.281 93.4842 89.8606V98.4414C93.4842 100.021 94.7651 101.302 96.3446 101.302C97.9245 101.302 99.205 100.021 99.205 98.4414V89.8606C99.205 88.2806 97.9245 87.0002 96.3446 87.0002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_18"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 87.0002C94.7647 87.0002 93.4842 88.281 93.4842 89.8606V98.4414C93.4842 100.021 94.7651 101.302 96.3446 101.302C97.9245 101.302 99.205 100.021 99.205 98.4414V89.8606C99.205 88.2806 97.9245 87.0002 96.3446 87.0002Z",
    fill: "url(#paint9_linear_406_2236)",
    className: "skbtPsrQ_19"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 162.082C94.7647 162.082 93.4842 163.363 93.4842 164.942V173.523C93.4842 175.103 94.7651 176.384 96.3446 176.384C97.9245 176.384 99.205 175.103 99.205 173.523V164.942C99.205 163.363 97.9245 162.082 96.3446 162.082Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 162.082C94.7647 162.082 93.4842 163.363 93.4842 164.942V173.523C93.4842 175.103 94.7651 176.384 96.3446 176.384C97.9245 176.384 99.205 175.103 99.205 173.523V164.942C99.205 163.363 97.9245 162.082 96.3446 162.082Z",
    fill: "url(#paint10_linear_406_2236)",
    className: "skbtPsrQ_21"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 137.055C94.7647 137.055 93.4842 138.336 93.4842 139.915V148.496C93.4842 150.076 94.7651 151.356 96.3446 151.356C97.9245 151.356 99.205 150.076 99.205 148.496V139.915C99.205 138.336 97.9245 137.055 96.3446 137.055Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_22"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 137.055C94.7647 137.055 93.4842 138.336 93.4842 139.915V148.496C93.4842 150.076 94.7651 151.356 96.3446 151.356C97.9245 151.356 99.205 150.076 99.205 148.496V139.915C99.205 138.336 97.9245 137.055 96.3446 137.055Z",
    fill: "url(#paint11_linear_406_2236)",
    className: "skbtPsrQ_23"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 112.028C94.7647 112.028 93.4842 113.309 93.4842 114.888V123.469C93.4842 125.049 94.7651 126.329 96.3446 126.329C97.9245 126.329 99.205 125.049 99.205 123.469V114.888C99.205 113.308 97.9245 112.028 96.3446 112.028Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_24"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3446 112.028C94.7647 112.028 93.4842 113.309 93.4842 114.888V123.469C93.4842 125.049 94.7651 126.329 96.3446 126.329C97.9245 126.329 99.205 125.049 99.205 123.469V114.888C99.205 113.308 97.9245 112.028 96.3446 112.028Z",
    fill: "url(#paint12_linear_406_2236)",
    className: "skbtPsrQ_25"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 161.211H124.803C123.223 161.211 121.943 162.492 121.943 164.071C121.943 165.651 123.223 166.932 124.803 166.932H156.448C158.028 166.932 159.308 165.651 159.308 164.071C159.308 162.492 158.028 161.211 156.448 161.211Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 161.211H124.803C123.223 161.211 121.943 162.492 121.943 164.071C121.943 165.651 123.223 166.932 124.803 166.932H156.448C158.028 166.932 159.308 165.651 159.308 164.071C159.308 162.492 158.028 161.211 156.448 161.211Z",
    fill: "url(#paint13_linear_406_2236)",
    className: "skbtPsrQ_27"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 174.732H124.803C123.223 174.732 121.943 176.013 121.943 177.592C121.943 179.172 123.223 180.453 124.803 180.453H156.448C158.028 180.453 159.308 179.172 159.308 177.592C159.308 176.012 158.028 174.732 156.448 174.732Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_28"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 174.732H124.803C123.223 174.732 121.943 176.013 121.943 177.592C121.943 179.172 123.223 180.453 124.803 180.453H156.448C158.028 180.453 159.308 179.172 159.308 177.592C159.308 176.012 158.028 174.732 156.448 174.732Z",
    fill: "url(#paint14_linear_406_2236)",
    className: "skbtPsrQ_29"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 147.691H124.803C123.223 147.691 121.943 148.972 121.943 150.551C121.943 152.131 123.223 153.411 124.803 153.411H156.448C158.028 153.411 159.308 152.131 159.308 150.551C159.308 148.972 158.028 147.691 156.448 147.691Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_30"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 147.691H124.803C123.223 147.691 121.943 148.972 121.943 150.551C121.943 152.131 123.223 153.411 124.803 153.411H156.448C158.028 153.411 159.308 152.131 159.308 150.551C159.308 148.972 158.028 147.691 156.448 147.691Z",
    fill: "url(#paint15_linear_406_2236)",
    className: "skbtPsrQ_31"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 107.128H124.803C123.223 107.128 121.943 108.409 121.943 109.989C121.943 111.568 123.223 112.849 124.803 112.849H156.448C158.028 112.849 159.308 111.568 159.308 109.989C159.308 108.409 158.028 107.128 156.448 107.128Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_32"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 107.128H124.803C123.223 107.128 121.943 108.409 121.943 109.989C121.943 111.568 123.223 112.849 124.803 112.849H156.448C158.028 112.849 159.308 111.568 159.308 109.989C159.308 108.409 158.028 107.128 156.448 107.128Z",
    fill: "url(#paint16_linear_406_2236)",
    className: "skbtPsrQ_33"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 134.17H124.803C123.223 134.17 121.943 135.45 121.943 137.03C121.943 138.61 123.223 139.89 124.803 139.89H156.448C158.028 139.89 159.308 138.61 159.308 137.03C159.308 135.45 158.028 134.17 156.448 134.17Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_34"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 134.17H124.803C123.223 134.17 121.943 135.45 121.943 137.03C121.943 138.61 123.223 139.89 124.803 139.89H156.448C158.028 139.89 159.308 138.61 159.308 137.03C159.308 135.45 158.028 134.17 156.448 134.17Z",
    fill: "url(#paint17_linear_406_2236)",
    className: "skbtPsrQ_35"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 120.649H124.803C123.223 120.649 121.943 121.93 121.943 123.51C121.943 125.089 123.223 126.37 124.803 126.37H156.448C158.028 126.37 159.308 125.089 159.308 123.51C159.308 121.93 158.028 120.649 156.448 120.649Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_36"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 120.649H124.803C123.223 120.649 121.943 121.93 121.943 123.51C121.943 125.089 123.223 126.37 124.803 126.37H156.448C158.028 126.37 159.308 125.089 159.308 123.51C159.308 121.93 158.028 120.649 156.448 120.649Z",
    fill: "url(#paint18_linear_406_2236)",
    className: "skbtPsrQ_37"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7981 129.104C13.2182 129.104 11.9377 130.385 11.9377 131.965V139.401C11.9377 140.981 13.2182 142.262 14.7981 142.262C16.378 142.262 17.6585 140.981 17.6585 139.401V131.965C17.6585 130.385 16.3776 129.104 14.7981 129.104Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_38"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7981 129.104C13.2182 129.104 11.9377 130.385 11.9377 131.965V139.401C11.9377 140.981 13.2182 142.262 14.7981 142.262C16.378 142.262 17.6585 140.981 17.6585 139.401V131.965C17.6585 130.385 16.3776 129.104 14.7981 129.104Z",
    fill: "url(#paint19_linear_406_2236)",
    className: "skbtPsrQ_39"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7981 148.84C13.2182 148.84 11.9377 150.121 11.9377 151.701V159.137C11.9377 160.717 13.2182 161.998 14.7981 161.998C16.378 161.998 17.6585 160.717 17.6585 159.137V151.701C17.6585 150.121 16.3776 148.84 14.7981 148.84Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_40"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7981 148.84C13.2182 148.84 11.9377 150.121 11.9377 151.701V159.137C11.9377 160.717 13.2182 161.998 14.7981 161.998C16.378 161.998 17.6585 160.717 17.6585 159.137V151.701C17.6585 150.121 16.3776 148.84 14.7981 148.84Z",
    fill: "url(#paint20_linear_406_2236)",
    className: "skbtPsrQ_41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7981 168.576C13.2182 168.576 11.9377 169.857 11.9377 171.436V178.873C11.9377 180.452 13.2182 181.733 14.7981 181.733C16.378 181.733 17.6585 180.452 17.6585 178.873V171.436C17.6585 169.856 16.3776 168.576 14.7981 168.576Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_42"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7981 168.576C13.2182 168.576 11.9377 169.857 11.9377 171.436V178.873C11.9377 180.452 13.2182 181.733 14.7981 181.733C16.378 181.733 17.6585 180.452 17.6585 178.873V171.436C17.6585 169.856 16.3776 168.576 14.7981 168.576Z",
    fill: "url(#paint21_linear_406_2236)",
    className: "skbtPsrQ_43"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M178.885 157.504C177.305 157.504 176.025 158.785 176.025 160.365V168.46C176.025 170.039 177.305 171.32 178.885 171.32C180.465 171.32 181.746 170.039 181.746 168.46V160.365C181.746 158.785 180.465 157.504 178.885 157.504Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_44"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M178.885 157.504C177.305 157.504 176.025 158.785 176.025 160.365V168.46C176.025 170.039 177.305 171.32 178.885 171.32C180.465 171.32 181.746 170.039 181.746 168.46V160.365C181.746 158.785 180.465 157.504 178.885 157.504Z",
    fill: "url(#paint22_linear_406_2236)",
    className: "skbtPsrQ_45"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M170.499 55.1078H135.605C134.025 55.1078 132.744 56.3886 132.744 57.9681C132.744 59.5477 134.025 60.8285 135.605 60.8285H170.499C172.079 60.8285 173.36 59.5477 173.36 57.9681C173.36 56.3886 172.079 55.1078 170.499 55.1078Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_46"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M170.499 55.1078H135.605C134.025 55.1078 132.744 56.3886 132.744 57.9681C132.744 59.5477 134.025 60.8285 135.605 60.8285H170.499C172.079 60.8285 173.36 59.5477 173.36 57.9681C173.36 56.3886 172.079 55.1078 170.499 55.1078Z",
    fill: "url(#paint23_linear_406_2236)",
    className: "skbtPsrQ_47"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M181.368 67.1208H156.198C154.618 67.1208 153.338 68.4016 153.338 69.9811C153.338 71.5607 154.618 72.8415 156.198 72.8415H181.368C182.948 72.8415 184.229 71.5607 184.229 69.9811C184.229 68.4016 182.948 67.1208 181.368 67.1208Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_48"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M181.368 67.1208H156.198C154.618 67.1208 153.338 68.4016 153.338 69.9811C153.338 71.5607 154.618 72.8415 156.198 72.8415H181.368C182.948 72.8415 184.229 71.5607 184.229 69.9811C184.229 68.4016 182.948 67.1208 181.368 67.1208Z",
    fill: "url(#paint24_linear_406_2236)",
    className: "skbtPsrQ_49"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51.513 21.3571H26.3427C24.7628 21.3571 23.4823 22.6379 23.4823 24.2175C23.4823 25.797 24.7632 27.0779 26.3427 27.0779H51.513C53.0929 27.0779 54.3734 25.797 54.3734 24.2175C54.3734 22.6379 53.0933 21.3571 51.513 21.3571Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_50"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M51.513 21.3571H26.3427C24.7628 21.3571 23.4823 22.6379 23.4823 24.2175C23.4823 25.797 24.7632 27.0779 26.3427 27.0779H51.513C53.0929 27.0779 54.3734 25.797 54.3734 24.2175C54.3734 22.6379 53.0933 21.3571 51.513 21.3571Z",
    fill: "url(#paint25_linear_406_2236)",
    className: "skbtPsrQ_51"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2119 30.8911H12.042C10.4621 30.8911 9.18163 32.172 9.18163 33.7515C9.18163 35.331 10.4625 36.6119 12.042 36.6119H37.2123C38.7922 36.6119 40.0727 35.331 40.0727 33.7515C40.0727 32.172 38.7922 30.8911 37.2119 30.8911Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "skbtPsrQ_52"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2119 30.8911H12.042C10.4621 30.8911 9.18163 32.172 9.18163 33.7515C9.18163 35.331 10.4625 36.6119 12.042 36.6119H37.2123C38.7922 36.6119 40.0727 35.331 40.0727 33.7515C40.0727 32.172 38.7922 30.8911 37.2119 30.8911Z",
    fill: "url(#paint26_linear_406_2236)",
    className: "skbtPsrQ_53"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_406_2236",
    x1: 96.2994,
    y1: 0,
    x2: 96.2994,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.141296d1a5dfcd55f0e4b6c143c42b19.svg";
export { ForwardRef as ReactComponent };